/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_G_NotifyInputs */

const tr_landing_integrations_g_notify = /** @type {(inputs: Landing_Integrations_G_NotifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirim`)
};

const en_landing_integrations_g_notify = /** @type {(inputs: Landing_Integrations_G_NotifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const de_landing_integrations_g_notify = /** @type {(inputs: Landing_Integrations_G_NotifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigung`)
};

const ru_landing_integrations_g_notify = /** @type {(inputs: Landing_Integrations_G_NotifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Landing_Integrations_G_NotifyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_g_notify = /** @type {((inputs?: Landing_Integrations_G_NotifyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_G_NotifyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_g_notify(inputs)
	if (locale === "de") return de_landing_integrations_g_notify(inputs)
	if (locale === "ru") return ru_landing_integrations_g_notify(inputs)
	return tr_landing_integrations_g_notify(inputs)
});